import { FC } from 'react';
import useConfigurationStep from './ConfigurationStep.hook';
import { CepConfigurationStep } from 'components/CepForm/Steps/ConfigurationStep/ConfigurationStep.types';
import CepFormConfigurationGroup from 'groups/CepFormConfigurationGroup';
import Box from 'yoda-ui/components/Box';

const ConfigurationStep: FC<CepConfigurationStep> = ({ isTemplate }) => {
  useConfigurationStep();
  return (
    <Box>
      <CepFormConfigurationGroup isTemplate={ isTemplate }/>
    </Box>
  );
};

export default ConfigurationStep;
